import { QueryClient } from "@tanstack/react-query";

/**
 * Client TanStack Query partagé.
 *
 * - `staleTime` court par défaut (données live) ; les pages wiki relèvent le leur
 *   (les registres ne changent qu'au reboot serveur — cf. SITE_SPEC §5).
 * - `retry` limité : une `ApiError` d'auth (401/403) ne doit pas être re-tentée.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/** `staleTime` recommandé pour le wiki (données quasi-immuables). */
export const WIKI_STALE_TIME = 60 * 60_000;
